import { images } from '../constants';

const blogs = [
{
  id: 1,
  image: images.blog1,
  category: "fabric care",
  date: "2 Jun, 2024",
  admin: "Admin",
  heading: "Choosing the Right Laundry Detergent",
  important: {
    content: "Selecting the right laundry detergent is essential for keeping your clothes clean, fresh, and lasting longer. Understanding detergent types and their uses will help you make the best choice for your laundry needs.",
    intro: "Laundry Expert"
  },
  paragraph: {
    para1: "Learn how to pick the best detergent for your fabrics and washing machine. From powders to liquids and pods, discover what works best for your laundry routine.",
    para2: "Explore the pros and cons of different detergent types, including eco-friendly options that are gentle on the environment and your clothes.",
    para3: "Get practical tips on using detergents effectively to remove stains, preserve colors, and maintain fabric softness. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Understand the key ingredients in detergents and how they impact cleaning performance. Make informed decisions to keep your laundry fresh and spotless. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog1Gallery1,
    images.blog1Gallery2
  ],
  tags: ["Laundry", "Detergent", "Care"],
  comments: [
    {
      id: 1,
      image: images.blog1Comment1,
      name: "Benjamin Alexander",
      date: "04 Feb, 2025",
      content: "Great tips on choosing detergents that actually work for different fabric types!",
      replies: [
        {
          id: 1,
          image: images.blog1Comment2,
          name: "Isabella Grace",
          date: "05 Feb, 2025",
          content: "I found the eco-friendly options really helpful for my sensitive skin."
        }
      ]
    },
    {
      id: 2,
      image: images.blog1Comment3,
      name: "Samuel James",
      date: "05 Feb, 2025",
      content: "This guide made me rethink the detergent I’ve been using. Thanks for the info!"
    }
  ]
},
{
  id: 2,
  image: images.blog2,
  category: "Laundry Hacks",
  date: "28 May, 2025",
  admin: "Admin",
  heading: "Efficient Clothes Folding Techniques",
  important: {
    content: "Mastering efficient clothes folding can save you time, keep your wardrobe organized, and help your garments last longer by reducing wrinkles and wear.",
    intro: "Organization Expert"
  },
  paragraph: {
    para1: "Discover simple and effective folding methods for different types of clothing, from shirts and pants to delicate fabrics. These techniques help maximize space and maintain neatness.",
    para2: "Learn how to fold your clothes like a pro using step-by-step guides and tips to speed up your laundry routine and keep your drawers tidy.",
    para3: "Explore tricks for packing clothes efficiently for travel and storage while preventing creases and damage. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Incorporate these folding strategies into your daily routine to enjoy a clutter-free closet and easier outfit selection. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog2Gallery1,
    images.blog2Gallery2
  ],
  tags: ["Folding", "Laundry", "Organizing"],
  comments: [
    {
      id: 1,
      image: images.blog2Comment1,
      name: "Jessica Lee",
      date: "23 Dec, 2025",
      content: "These folding tips really helped me organize my closet better!",
      replies: [
        {
          id: 1,
          image: images.blog2Comment2,
          name: "Michael Brown",
          date: "24 Dec, 2025",
          content: "I love the travel packing folding hacks!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog2Comment3,
      name: "Emily Clark",
      date: "25 Dec, 2025",
      content: "Great guide, makes folding clothes less of a chore."
    }
  ]
},
{
  id: 3,
  image: images.blog3,
  category: "Eco-Friendly",
  date: "22 May, 2025",
  admin: "Admin",
  heading: "Sustainable Laundry Detergent Options",
  important: {
    content: "Choosing sustainable laundry detergents helps reduce your environmental footprint while keeping your clothes clean and fresh. Learn about effective eco-friendly detergent choices.",
    intro: "Environmental Advocate"
  },
  paragraph: {
    para1: "Explore various eco-friendly detergents made with biodegradable ingredients that are safe for both your fabrics and the planet.",
    para2: "Understand the benefits of using natural and organic detergents, including reduced chemical exposure and improved water quality.",
    para3: "Discover how sustainable detergents can work just as well as conventional ones, with tips for maximizing their effectiveness. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Learn how to make informed choices to protect your health and the environment without sacrificing laundry performance. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog3Gallery1,
    images.blog3Gallery2
  ],
  tags: ["Eco", "Detergent", "Care"],
  comments: [
    {
      id: 1,
      image: images.blog3Comment1,
      name: "Laura Green",
      date: "11 Dec, 2025",
      content: "I switched to sustainable detergents and my skin feels so much better!",
      replies: [
        {
          id: 1,
          image: images.blog3Comment2,
          name: "Tom Harris",
          date: "12 Dec, 2025",
          content: "Great to know these options are actually effective and safe."
        }
      ]
    },
    {
      id: 2,
      image: images.blog3Comment3,
      name: "Sophie Martin",
      date: "13 Dec, 2025",
      content: "This guide helped me make better eco-friendly choices."
    }
  ]
},
{
  id: 4,
  image: images.blog4,
  category: "Fabric Care",
  date: "15 May, 2025",
  admin: "Admin",
  heading: "Caring for Delicate Fabrics Guide",
  important: {
    content: "Proper care for delicate fabrics ensures your garments stay beautiful and last longer. Learn the best practices for washing, drying, and storing sensitive materials.",
    intro: "Textile Specialist"
  },
  paragraph: {
    para1: "Understand the unique needs of delicate fabrics such as silk, lace, and chiffon, and how to handle them with care during laundry.",
    para2: "Learn gentle washing techniques, recommended detergents, and drying methods that preserve fabric integrity and prevent damage.",
    para3: "Discover tips for stain removal and storage that help maintain the softness and appearance of your delicate clothing. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Incorporate these care guidelines into your routine to extend the life of your favorite delicate pieces and keep them looking fresh. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog4Gallery1,
    images.blog4Gallery2
  ],
  tags: ["Fabric", "Care", "Laundry"],
  comments: [
    {
      id: 1,
      image: images.blog4Comment1,
      name: "Megan Foster",
      date: "26 Nov, 2025",
      content: "These tips saved my silk blouse from ruining!",
      replies: [
        {
          id: 1,
          image: images.blog4Comment2,
          name: "Daniel Reed",
          date: "27 Nov, 2025",
          content: "Great advice for delicate fabrics, thanks!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog4Comment3,
      name: "Samantha Cole",
      date: "28 Nov, 2025",
      content: "A very helpful guide for handling delicate clothes."
    }
  ]
},
{
  id: 5,
  image: images.blog5,
  category: "Wardrobe Maintenance",
  date: "8 May, 2025",
  admin: "Admin",
  heading: "Organizing Your Laundry Room",
  important: {
    content: "A well-organized laundry room can make your chores easier and more efficient. Discover smart storage and layout ideas to create a tidy and functional space.",
    intro: "Home Organization Expert"
  },
  paragraph: {
    para1: "Learn practical tips for arranging laundry essentials like detergents, cleaning tools, and hampers to maximize space and accessibility.",
    para2: "Explore clever storage solutions and layout designs that keep your laundry room neat and clutter-free.",
    para3: "Get inspired by ideas for multi-purpose use of the laundry area, combining it with other household functions. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Implement these organization strategies to transform your laundry room into a pleasant and productive space. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog5Gallery1,
    images.blog5Gallery2
  ],
  tags: ["Organizing", "Laundry", "Folding"],
  comments: [
    {
      id: 1,
      image: images.blog5Comment1,
      name: "Olivia Parker",
      date: "19 Nov, 2025",
      content: "These organizing tips helped me declutter my laundry space!",
      replies: [
        {
          id: 1,
          image: images.blog5Comment2,
          name: "Ethan Ward",
          date: "20 Nov, 2025",
          content: "Great ideas for small laundry rooms."
        }
      ]
    },
    {
      id: 2,
      image: images.blog5Comment3,
      name: "Grace Wilson",
      date: "21 Nov, 2025",
      content: "I love the storage hacks shared here!"
    }
  ]
},
{
  id: 6,
  image: images.blog6,
  category: "Dry Cleaning",
  date: "30 Apr, 2025",
  admin: "Admin",
  heading: "Silk and Wool Dry Cleaning Tips",
  important: {
    content: "Proper dry cleaning of silk and wool fabrics preserves their quality and extends their lifespan. Learn expert tips to keep these delicate materials looking their best.",
    intro: "Dry Cleaning Specialist"
  },
  paragraph: {
    para1: "Understand the unique characteristics of silk and wool and why they require special care through professional dry cleaning.",
    para2: "Discover best practices for stain removal, handling, and storage of silk and wool garments to maintain their softness and durability.",
    para3: "Learn how to choose the right dry cleaner and what questions to ask to ensure your delicate items are treated properly. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Incorporate these dry cleaning tips into your garment care routine to protect your investment and keep your silk and wool pieces looking pristine. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog6Gallery1,
    images.blog6Gallery2
  ],
  tags: ["DryCleaning", "Fabric", "Care"],
  comments: [
    {
      id: 1,
      image: images.blog6Comment1,
      name: "Rachel Adams",
      date: "19 Nov, 2025",
      content: "I never knew dry cleaning silk required so much care!",
      replies: [
        {
          id: 1,
          image: images.blog6Comment2,
          name: "Michael Scott",
          date: "20 Nov, 2025",
          content: "Great advice for maintaining wool garments."
        }
      ]
    },
    {
      id: 2,
      image: images.blog6Comment3,
      name: "Emily Carter",
      date: "21 Nov, 2025",
      content: "This post helped me understand proper dry cleaning better."
    }
  ]
},
{
  id: 7,
  image: images.blog7,
  category: "Laundry Hacks",
  date: "21 Apr, 2025",
  admin: "Admin",
  heading: "How to Pick the Best Laundry Detergent",
  important: {
    content: "Choosing the right laundry detergent is essential for keeping your clothes clean and fresh without damaging fabrics. Learn how to select the detergent that fits your laundry needs.",
    intro: "Laundry Expert"
  },
  paragraph: {
    para1: "Explore the different types of detergents available, from liquids to powders and pods, and their benefits for various fabrics and washing machines.",
    para2: "Understand key ingredients and their effects on stain removal, scent, and fabric care to make an informed choice.",
    para3: "Discover eco-friendly and hypoallergenic detergent options for sensitive skin and environmental sustainability. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Apply these tips to pick the detergent that keeps your laundry spotless and your fabrics protected. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog7Gallery1,
    images.blog7Gallery2
  ],
  tags: ["Detergent", "Care", "Laundry"],
  comments: [
    {
      id: 1,
      image: images.blog7Comment1,
      name: "Alice Johnson",
      date: "31 Dec, 2025",
      content: "This guide helped me find the perfect detergent for my sensitive skin.",
      replies: [
        {
          id: 1,
          image: images.blog7Comment2,
          name: "Mark Thompson",
          date: "01 Jan, 2024",
          content: "Great tips for eco-friendly detergent choices!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog7Comment3,
      name: "Linda Baker",
      date: "02 Jan, 2024",
      content: "Very informative and easy to understand."
    }
  ]
},
{
  id: 8,
  image: images.blog8,
  category: "Laundry Hacks",
  date: "13 Apr, 2025",
  admin: "Admin",
  heading: "Smart Methods for Folding Clothes",
  important: {
    content: "Efficient folding techniques can save space and keep your clothes looking neat and wrinkle-free. Discover smart methods to streamline your laundry routine.",
    intro: "Organization Specialist"
  },
  paragraph: {
    para1: "Learn easy and effective folding styles for different types of clothing, including shirts, pants, and delicate items.",
    para2: "Explore space-saving folding tricks that help you organize drawers and suitcases better.",
    para3: "Get tips on maintaining fabric shape and avoiding wrinkles through proper folding. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Implement these folding methods to make laundry tasks quicker and keep your wardrobe tidy and organized. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog8Gallery1,
    images.blog8Gallery2
  ],
  tags: ["Folding", "Organizing", "Laundry"],
  comments: [
    {
      id: 1,
      image: images.blog8Comment1,
      name: "Sophia Lee",
      date: "23 Dec, 2025",
      content: "These folding tips saved me so much space in my drawers!",
      replies: [
        {
          id: 1,
          image: images.blog8Comment2,
          name: "James Miller",
          date: "24 Dec, 2025",
          content: "I love the wrinkle-free folding techniques shared here."
        }
      ]
    },
    {
      id: 2,
      image: images.blog8Comment3,
      name: "Mia Davis",
      date: "25 Dec, 2025",
      content: "Very practical and easy to follow!"
    }
  ]
},
{
  id: 9,
  image: images.blog9,
  category: "Eco-Friendly",
  date: "1 Apr, 2025",
  admin: "Admin",
  heading: "Eco-Friendly Laundry Detergent Choices",
  important: {
    content: "Choosing environmentally friendly laundry detergents helps protect the planet while keeping your clothes clean and fresh.",
    intro: "Sustainability Advocate"
  },
  paragraph: {
    para1: "Explore various eco-friendly detergent options that minimize chemical impact and promote sustainable living.",
    para2: "Learn about biodegradable ingredients and packaging that reduce environmental footprint.",
    para3: "Discover how to select detergents suitable for sensitive skin without compromising on cleaning power. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Incorporate these green detergent choices into your laundry routine for a cleaner home and a healthier planet. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog9Gallery1,
    images.blog9Gallery2
  ],
  tags: ["Eco", "Detergent", "Laundry"],
  comments: [
    {
      id: 1,
      image: images.blog9Comment1,
      name: "Grace Turner",
      date: "11 Dec, 2025",
      content: "I love these eco-friendly detergent recommendations!",
      replies: [
        {
          id: 1,
          image: images.blog9Comment2,
          name: "Ethan Wilson",
          date: "12 Dec, 2025",
          content: "Great tips for reducing laundry’s environmental impact."
        }
      ]
    },
    {
      id: 2,
      image: images.blog9Comment3,
      name: "Olivia Martin",
      date: "13 Dec, 2025",
      content: "Very informative and helpful for green living."
    }
  ]
},
{
  id: 10,
  image: images.blog10,
  category: "Fabric Care",
  date: "25 Mar, 2025",
  admin: "Admin",
  heading: "Guide to Caring for Sensitive Fabrics",
  important: {
    content: "Proper care for delicate and sensitive fabrics helps maintain their beauty and prolongs their lifespan.",
    intro: "Fabric Care Specialist"
  },
  paragraph: {
    para1: "Learn essential tips for washing, drying, and storing delicate fabrics like silk, wool, and lace to avoid damage.",
    para2: "Discover the best detergents and washing techniques tailored for sensitive materials to preserve texture and color.",
    para3: "Understand common mistakes and how to prevent fabric wear and tear during everyday laundry. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Follow this guide to keep your sensitive fabrics looking fresh and elegant for years to come. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog10Gallery1,
    images.blog10Gallery2
  ],
  tags: ["Fabric", "Care", "Laundry"],
  comments: [
    {
      id: 1,
      image: images.blog10Comment1,
      name: "Emily Clark",
      date: "26 Nov, 2025",
      content: "These tips really helped me take better care of my silk clothes!",
      replies: [
        {
          id: 1,
          image: images.blog10Comment2,
          name: "Michael Scott",
          date: "27 Nov, 2025",
          content: "Very useful advice for delicate fabric care."
        }
      ]
    },
    {
      id: 2,
      image: images.blog10Comment3,
      name: "Sarah Lewis",
      date: "28 Nov, 2025",
      content: "Easy to follow and practical guide!"
    }
  ]
},
{
  id: 11,
  image: images.blog11,
  category: "Wardrobe Maintenance",
  date: "11 Mar, 2025",
  admin: "Admin",
  heading: "Tips for Arranging Your Laundry Area",
  important: {
    content: "A well-organized laundry area boosts efficiency and makes laundry tasks easier and more enjoyable.",
    intro: "Organization Expert"
  },
  paragraph: {
    para1: "Discover practical ideas for arranging your laundry space to maximize storage and improve workflow.",
    para2: "Learn about smart storage solutions, shelving, and tools that keep your laundry essentials accessible and tidy.",
    para3: "Find out how to create a functional and pleasant laundry environment that fits your lifestyle. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Implement these tips to transform your laundry area into a well-organized and stress-free space. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog11Gallery1,
    images.blog11Gallery2
  ],
  tags: ["Organizing", "Laundry", "Folding"],
  comments: [
    {
      id: 1,
      image: images.blog11Comment1,
      name: "Anna Roberts",
      date: "19 Nov, 2025",
      content: "These tips made my laundry space so much more functional!",
      replies: [
        {
          id: 1,
          image: images.blog11Comment2,
          name: "David Miller",
          date: "20 Nov, 2025",
          content: "Great advice on storage solutions."
        }
      ]
    },
    {
      id: 2,
      image: images.blog11Comment3,
      name: "Jessica Taylor",
      date: "21 Nov, 2025",
      content: "I love the ideas shared here for organizing my laundry room."
    }
  ]
},
{
  id: 12,
  image: images.blog12,
  category: "Dry Cleaning",
  date: "5 Mar, 2025",
  admin: "Admin",
  heading: "Best Practices for Dry Cleaning Silk and Wool",
  important: {
    content: "Proper dry cleaning techniques preserve the quality and longevity of delicate silk and wool garments.",
    intro: "Dry Cleaning Specialist"
  },
  paragraph: {
    para1: "Learn essential dry cleaning tips to safely clean and maintain your silk and wool clothing.",
    para2: "Discover the best solvents and methods used by professionals to protect delicate fibers.",
    para3: "Understand common mistakes to avoid that can damage these sensitive fabrics. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
    para4: "Follow these best practices to keep your silk and wool garments looking fresh and luxurious. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
  },
  gallery: [
    images.blog12Gallery1,
    images.blog12Gallery2
  ],
  tags: ["DryCleaning", "Fabric", "Care"],
  comments: [
    {
      id: 1,
      image: images.blog12Comment1,
      name: "Laura Bennett",
      date: "19 Nov, 2025",
      content: "Fantastic advice for keeping my wool sweaters in great shape!",
      replies: [
        {
          id: 1,
          image: images.blog12Comment2,
          name: "James Parker",
          date: "20 Nov, 2025",
          content: "Very helpful dry cleaning tips."
        }
      ]
    },
    {
      id: 2,
      image: images.blog12Comment3,
      name: "Sophia Evans",
      date: "21 Nov, 2025",
      content: "Great guide for delicate fabric care!"
    }
  ]
}

];

export default blogs;